import React from 'react'
import { Table } from 'react-bootstrap'
import DataTables from '../../Main/DataTable/DataTables';

const UserTransaction = ({ userTransaction }) => {




    const columns = [

        { name: 'Order Id', selector: row => row?.order_id },
        { name: 'Amount', selector: row => row.amount },
        { name: 'Withdrawable', selector: row => row.withdrawable_at_days },
        { name: 'Status', selector: row => row.status },
        { name: 'Date', selector: row => row.created_at },
    ];

    return (


        <>
            <DataTables filter={false} columns={columns} data={userTransaction} />
        </>
    )
}

export default UserTransaction